import { CUSTOMER_ACCOUNT_TYPE } from "./customers.constants";
import { useAccountTypeBrowse } from "@features/tickets/shared/hooks/useAccountTypeBrowse";

export function useCustomersBrowse() {
  return useAccountTypeBrowse({
    accountType: CUSTOMER_ACCOUNT_TYPE,
    withRelations: true,
  });
}
